import React from "react";
import { localize } from "redux-i18n";
import { GSGrid, SectionComponent } from "@components";
import type { FirstCareIndexPageStatisticArrayItem } from "@modules/reporting/reducer/dashboard/types";

import "./styles.scss";

type Props = $Exact<{
  reportData: Array<FirstCareIndexPageStatisticArrayItem>,
  title?: stirng,
  height?: number,
  ...PropsFromLocalize,
}>;

const DashboardIndexTable = ({ t, reportData, title, height }: Props) => {
  return (
    <SectionComponent
      title={<h6 tabIndex="0">{title}</h6>}
      className="w-100 dashboard-table gs-container"
    >
      <GSGrid
        rows={reportData}
        columns={[
          {
            key: "measureTitle",
            name: t("MEASURE"),
            width: 250,
            align: "left",
          },
          {
            name: t("YOUR_STAFF"),
            align: "center",
            key: "yourStaff",
            renderCell: ({ row }: Object) => {
              return parseFloat(row.yourStaff || 0, 10).toFixed(2);
            },
          },
          {
            name: t("ORGANISATION_DLPE"),
            key: "organisationDlpe",
            align: "center",
            renderCell: ({ row }: Object) => {
              return GSGrid.render.trendIndicator(
                row.organisationDlpe,
                row.yourStaff,
                row.organisationDlpe,
              );
            },
          },
          {
            name: t("PERCENT_V_ORGANISATION"),
            key: "organisationPercentage",
            align: "center",
            renderCell: ({ column, row, rowIdx }: Object) => {
              return GSGrid.render.compareABcolorful(
                row.organisationPercentage,
                row.yourStaff,
                `${row.organisationPercentage}%`,
              );
            },
          },
          {
            name: t("INDUSTRY_DLPE"),
            key: "industryDlpe",
            align: "center",
            renderCell: ({ column, row, rowIdx }: Object) => {
              return GSGrid.render.trendIndicator(
                row.industryDlpe,
                row.yourStaff,
                row.industryDlpe,
              );
            },
          },
          {
            name: t("PERCENT_V_INDUSTRY"),
            key: "industryPercentage",
            align: "center",
            renderCell: ({ column, row, rowIdx }: Object) => {
              return GSGrid.render.compareABcolorful(
                row.industryPercentage,
                row.yourStaff,
                `${row.industryPercentage}%`,
              );
            },
          },
          {
            name: t("NATIONAL_DLPE"),
            key: "nationalDlpe",
            align: "center",
            renderCell: ({ column, row, rowIdx }: Object) => {
              return GSGrid.render.trendIndicator(
                row.nationalDlpe,
                row.yourStaff,
                row.nationalDlpe,
              );
            },
          },
          {
            name: t("PERCENT_V_NATIONAL"),
            key: "nationalPercentage",
            align: "center",
            renderCell: ({ column, row, rowIdx }: Object) => {
              return GSGrid.render.compareABcolorful(
                row.nationalPercentage,
                row.yourStaff,
                `${row.nationalPercentage}%`,
              );
            },
          },
        ]}
      />
    </SectionComponent>
  );
};

export default localize()(DashboardIndexTable);
